__turbopack_context__.v({
  "customInput": "index-module__r_Hv7q__customInput",
  "fontTypeLarge": "index-module__r_Hv7q__fontTypeLarge",
  "fontTypeSmall": "index-module__r_Hv7q__fontTypeSmall",
});
